<template>
  <div>
    <svg class="spinner" viewBox="0 0 66 66"
         xmlns="http://www.w3.org/2000/svg">
      <circle class="path" fill="none" stroke-width="3" stroke-linecap="square"
              cx="33" cy="33" r="30"></circle>
    </svg>
  </div>
</template>

<script>

export default {
  name: 'Spinner'
};
</script>

<style scoped lang="scss">

  @import "../style/color_";

  .spinner {
    animation: rotator 1.4s linear infinite;
  }

  @keyframes rotator {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(270deg);
    }
  }

  .path {
    stroke-dasharray: 187;
    stroke-dashoffset: 0;
    transform-origin: center;
    animation: dash 1.4s ease-in-out infinite,
    colors 5.6s ease-in-out infinite;
  }

  @keyframes colors {
    0% {
      stroke: $color-cl-red;
      /*<!--stroke: $color-initial;-->*/
    }
    25% {
      stroke: $color-cl-red;
    }
    50% {
      stroke: $color-cl-red;
      /*stroke: #a4a4a4;*/
    }
    75% {
      stroke: $color-cl-red;
    }
    100% {
      stroke: $color-cl-red;
    }
  }

  @keyframes dash {
    0% {
      stroke-dashoffset: 187;
    }
    50% {
      stroke-dashoffset: 46.75;
      transform: rotate(135deg);
    }
    100% {
      stroke-dashoffset: 187;
      transform: rotate(450deg);
    }
  }
</style>
